import { Component, forwardRef, Input, OnDestroy, OnInit } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

import { CheckPersonRulesMatrixModel, PersonModel } from '@bayclubs/court-booking-employee-api';

import { CourtBookingSaveFacade } from './../../+store/court-booking-save.facade';

export const CUSTOM_PLAYER_ADD_VALUE_ACCESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => CourtBookingSavePlayerAddComponent),
    multi: true
};

@Component({
    selector: 'app-court-booking-save-player-add',
    templateUrl: './court-booking-save-player-add.component.html',
    styleUrls: ['./court-booking-save-player-add.component.scss'],
    providers: [CUSTOM_PLAYER_ADD_VALUE_ACCESSOR],
    standalone: false
})
export class CourtBookingSavePlayerAddComponent implements OnInit, OnDestroy, ControlValueAccessor {
    @Input() playerRules: CheckPersonRulesMatrixModel;
    @Input() categoryName: string;
    @Input() players: PersonModel[];

    selectedPerson: PersonModel = null;

    selectedTab: PlayerChangeTab = PlayerChangeTab.searchPlayerTab;

    constructor(private courtBookingSaveFacade: CourtBookingSaveFacade) { }

    onChange = (selected: PersonModel) => { };
    onTouched = () => { };
    writeValue(person: PersonModel): void {
        this.selectedPerson = person;
    }
    registerOnChange(fn: any): void {
        this.onChange = fn;
    }
    registerOnTouched(fn: any): void {
        this.onTouched = fn;
    }
    setDisabledState?(isDisabled: boolean): void { }

    ngOnInit(): void {
    }

    ngOnDestroy(): void {
    }


    selectPerson(person: PersonModel) {
        this.selectedPerson = person;
        this.onChange(person);
        this.courtBookingSaveFacade.clearPlayers();
    }

    clearSelectedPerson() {
        this.selectedPerson = null;
        this.onChange(null);
    }

    setSearchTabActive() {
        this.courtBookingSaveFacade.clearPlayers();
        this.selectedTab = PlayerChangeTab.searchPlayerTab;
    }

    setAddPlayerTabActive() {
        this.courtBookingSaveFacade.clearPlayers();
        this.selectedTab = PlayerChangeTab.addNewPlayerTab;
    }


    get isSearchTabActive(): boolean {
        return this.selectedTab === PlayerChangeTab.searchPlayerTab;
    }

    get isAddNewPlayerTabActive(): boolean {
        return this.selectedTab === PlayerChangeTab.addNewPlayerTab;
    }

}

export interface CourtBookingPlayerSearchFormModel {
    search: string;
}

export enum PlayerChangeTab {
    searchPlayerTab,
    addNewPlayerTab
}
